import PropTypes from 'prop-types';
import React, { Children, cloneElement } from 'react';
import { FormHelperText, withStyles } from '@material-ui/core';
import { ValidatorComponent } from 'react-material-ui-form-validator';

import { VALIDATION_TYPES, renderRequiredLabel } from 'utilities/fieldValidation';

class SportsScaleCustomValidator extends ValidatorComponent {
  handleBlur = () => {
    const { disableBlurValidation, value, onBlur } = this.props;

    if (!disableBlurValidation) this.validate(value, true);

    onBlur(value);
  };

  renderLabel = label =>
    this.props.validators.includes(VALIDATION_TYPES.REQUIRED) ? renderRequiredLabel(label) : label;

  renderValidatorComponent() {
    const {
      children,
      classes,
      disableBlurValidation,
      errorMessages,
      label,
      requiredError,
      validatorListener,
      validators,
      onBlur,
      ...rest
    } = this.props;

    const { isValid } = this.state;
    const renderedLabel = this.renderLabel(label);

    return (
      <div className={classes.formControl}>
        {Children.map(children, child =>
          cloneElement(child, {
            label: renderedLabel,
            error: isValid !== undefined && !isValid,
            ...rest,
            hasValidation: true,
            ref: this.validatorRef,
            onBlur: this.handleBlur,
          })
        )}
        {isValid !== undefined && !isValid && (
          <FormHelperText classes={{ root: classes.helperText }} error>
            <span>{this.getErrorMessage()}</span>
          </FormHelperText>
        )}
      </div>
    );
  }
}

SportsScaleCustomValidator.propTypes = {
  classes: PropTypes.object.isRequired,

  disableBlurValidation: PropTypes.bool,
  label: PropTypes.string,
  name: PropTypes.string.isRequired,
  value: PropTypes.any,
};

SportsScaleCustomValidator.defaultProps = {
  disableBlurValidation: false,
  label: '',
  validatorListener: () => {},
  value: null,
};

const styles = () => ({
  helperText: {
    margin: '8px 14px 0', // copied from MuiFormHelperText to match build in validation error spacing
  },
});

export default withStyles(styles)(SportsScaleCustomValidator);
